import React from 'react';
import { BoxProps, Typography } from '@mui/material';
import CellContainer from 'shared/lib/extendedComponents/grids/components/cellContainer';

export default function TextCell({ children, ...other }: BoxProps) {
  return (
    <CellContainer {...other} sx={{ alignItems: 'start', ...other.sx }}>
      <Typography variant="f14" color="text.secondary">
        {children}
      </Typography>
    </CellContainer>
  );
}
